export default __webpack_public_path__ + "static/media/head01_vi_pc.9760508a.png";